import { ArrowLeft } from 'lucide-react'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog'
import { cn } from '../../lib/utils'
import { getPopupGraphic, getPopupLabel, getPopupVisualSeverity } from './popupGraphics'

const FullPagePopupLayout = ({
  isOpen,
  onClose,
  onBack,
  severity = 'notice',
  title,
  message,
  children,
  actions,
  bodyClassName,
  actionsClassName,
  contentClassName,
  disableDismiss = false,
}) => {
  const visualSeverity = getPopupVisualSeverity(severity)
  const graphic = getPopupGraphic(severity)
  const label = getPopupLabel(severity)

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && !disableDismiss && onClose?.()}>
      <DialogContent
        data-severity={visualSeverity}
        mobileFullscreen
        onEscapeKeyDown={(event) => {
          if (disableDismiss) event.preventDefault()
        }}
        className={cn(
          'fabits-global-popup fabits-global-popup-full z-[10001] p-0',
          contentClassName,
        )}
      >
        <DialogHeader className='contents'>
          <div className='fabits-global-popup-hero'>
            {onBack && (
              <button
                type='button'
                onClick={onBack}
                className='relative z-10 mb-4 inline-flex min-h-11 items-center gap-2 self-start rounded-md px-2 text-sm font-medium text-white transition-colors hover:bg-white/10 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white'
              >
                <ArrowLeft className='h-4 w-4' aria-hidden='true' />
              </button>
            )}
            <div className='fabits-global-popup-graphic-shell'>
              <img
                className='fabits-global-popup-graphic'
                src={graphic}
                alt=''
                aria-hidden='true'
              />
            </div>
            <p className='fabits-global-popup-eyebrow'>{label}</p>
            <DialogTitle className='fabits-global-popup-title'>{title}</DialogTitle>
          </div>
          {message && (
            <DialogDescription className='fabits-global-popup-description'>
              {message}
            </DialogDescription>
          )}
        </DialogHeader>

        {children && (
          <div className={cn('fabits-global-popup-body', bodyClassName)}>{children}</div>
        )}

        {actions && (
          <DialogFooter className={cn('fabits-global-popup-actions', actionsClassName)}>
            {actions}
          </DialogFooter>
        )}
      </DialogContent>
    </Dialog>
  )
}

export default FullPagePopupLayout
